// extracted by mini-css-extract-plugin
export default {"heading":"PageHeading_heading__Et+FA"};